import { Button, theme, Typography } from 'antd'
import dayjs from 'dayjs'
import { Trans, useTranslation } from 'react-i18next'
import employeeOnboarding from '../../resources/img/new-employee-onboarding.svg'

export function StepWelcome({
  onboarding: {
    company: { name },
    firstMonth,
  },
  goToNext,
}) {
  const { token } = theme.useToken()
  const { t } = useTranslation()

  return (
    <>
      <img
        src={employeeOnboarding}
        style={{
          position: 'absolute',
          width: 600,
          top: -55,
          right: -220,
          zIndex: 1,
        }}
        alt=""
      />
      <div
        style={{
          maxWidth: '35em',
          position: 'relative',
          textAlign: 'justify',
          zIndex: 2,
        }}
      >
        <Typography.Title level={3} style={{ marginBottom: token.marginLG }}>
          {t('frontend:onboarding.welcomeTitle')}
        </Typography.Title>
        {/*<div*/}
        {/*  style={{*/}
        {/*    textAlign: 'center',*/}
        {/*    width: '100%',*/}
        {/*    marginBottom: 20,*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <img src={files} alt="" style={{ height: 180 }} />*/}
        {/*</div>*/}
        {t('frontend:onboarding.welcomeSalutation')}
        <br />
        <br />
        <Typography.Paragraph>
          <Trans
            i18nKey="frontend:onboarding.welcomeIntro"
            components={{ strong: <strong /> }}
            values={{
              name,
              firstMonth: dayjs(firstMonth).format('MMMM YYYY'),
            }}
          />
        </Typography.Paragraph>
        <Typography.Paragraph>
          {t('frontend:onboarding.welcomeDataNeeded')}
        </Typography.Paragraph>
        <ul>
          <li>{t('frontend:onboarding.sectionClientMasterData')}</li>
          <li>{t('frontend:onboarding.welcomeListAccidentInsurance')}</li>
          <li>{t('frontend:onboarding.stepEmployeeMasterData')}</li>
          <li>
            {t('frontend:onboarding.welcomeListPreviousMonthPayslips', {
              month: dayjs(firstMonth).subtract(1, 'month').format('MMMM YYYY'),
            })}
          </li>
          <li>{t('frontend:onboarding.stepPaymentFile')}</li>
          {!firstMonth.endsWith('-01') && (
            <li>{t('frontend:onboarding.welcomeListPayrollAccounts')}</li>
          )}
          <li>{t('frontend:onboarding.welcomeListDlsFiles')}</li>
          <li>{t('frontend:onboarding.welcomeListAdditionalDocuments')}</li>
        </ul>
        <Typography.Paragraph>
          {t('frontend:onboarding.welcomeEnsureAccess')}
        </Typography.Paragraph>
        <Typography.Paragraph>
          <Trans
            i18nKey="frontend:onboarding.welcomeDuration"
            components={{ strong: <strong /> }}
          />
        </Typography.Paragraph>
        <div style={{ textAlign: 'center', marginTop: token.marginXXL }}>
          <Button onClick={() => goToNext()} type="primary">
            {t('frontend:onboarding.welcomeStart')}
          </Button>
        </div>
      </div>
    </>
  )
}
